import { Component, ComponentFactoryResolver, OnInit, ViewChild } from "@angular/core";

import { State, City } from "@shared/models";
import { ClientesService } from "../../services/clientes.service";
import { Utilservice } from "@core/services/util.service";
import * as toastr from 'toastr'
import * as _ from 'lodash';
import { LocationsService } from '@modules/clientes/services/locations.service';
import { UfComboComponent } from '@shared/components/uf-combo/uf-combo.component';
import { ConsultRequest } from '@shared/utils/consult-request';
import { Setor, Vendedor } from '@shared/models';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import { trackByHourSegment } from "angular-calendar/modules/common/util";

@Component({
  selector: "app-carteira-pedido",
  templateUrl: "./carteira-pedido.component.html",
  styleUrls: ["./carteira-pedido.component.css"]
})
export class CarteiraPedidoComponent implements OnInit {
  lsStates: State[] = [];
  lsCities: City[] = [];
  lsSetores: any[] = [];
  lsLinhas: any[] = [];
  lsStatus: any[] = [];
  lsPreco: any[] = [];
  lsClients: any[] = [];
  lsTotalStatus: any[] = [];
  lsVendedores: Vendedor[] = [];

  vendedor : Vendedor;
  city: City;
  vendedorLoading : boolean = false;
  cidadeLoading:  boolean = false;
  isRequesting: Boolean = false;
  parameters: any;
  vetorSetor: any;
  userLogado;
  setorFzs;

  private debouncedGetSetor =  _.debounce(()=>this.getIdSetorComc(), 1000, {
    'leading': false,
    'trailing': true
  })

  @ViewChild('ufsVendedor', {static: false}) ufViewChild: UfComboComponent;

  constructor(
    private clientService: ClientesService,
    private locationsService: LocationsService,
    private visitService: VisitasService,
    ) {}

  filtrarUf(){
    if(this.parameters.vendedor) {
      this.locationsService.listUFBySectorAndSeller(this.vetorSetor.codigo, this.parameters.vendedor.nome).subscribe(
        ufsFiltradas => {
          this.lsStates = ufsFiltradas;
          let sgMap = (ufsFiltradas.map(uf => uf.sgUf));
          this.ufViewChild.ufs = this.ufViewChild.ufs.filter(uf => sgMap.includes(uf.sgUf));
        }
      )
    }
  }

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.getLinhas();
    this.getSetores();
    this.getStatus();
    this.getPrecos();

    if(this.userLogado.perfil !== 3){
      //this.getStates(this.userLogado.setor);
      this.debouncedGetSetor();
      this.setorFzs = this.userLogado.setor;
    }

    this.lsTotalStatus = [];

    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.vetorSetor = {
        id: this.userLogado.idSetor,
        codigo: this.userLogado.setor,
      }
    }

    this.parameters = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : '',
      pedido: "",
      periodoInicial: "",
      periodoFinal: "",
      cnpj: "",
      uf: "",
      cidade: null,
      linhas: "",
      idStatus: "",
      idTabelaPreco: "",
      tipoConsulta: "",
      vendedor: null,
      CdFzs: "",
      pedidosReativos: false,
      pedidosComSaldo: false,
      pedidosTelevendas: false
    };
    
    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.getVendedores();
    }
  }

  getPrecos() {
    this.clientService.getPrecos().subscribe(
      data => {
        this.lsPreco = data;
      },
      error => console.log(error)
    );
  }

  getStatus() {
    this.clientService
      .getStatus()
      .subscribe(data => (
        this.lsStatus = data
      ), error => console.log(error));
  }

  getLinhas() {
    this.clientService.getLinhas().subscribe(
      data => {
        this.lsLinhas = data;

        const parameters = this.parameters;

        parameters.linhas = data[0].id;

        this.parameters = parameters;
      },
      error => console.log(error)
    );
  }

  getStates(id) {
    this.clientService
      .getStates(id)
      .subscribe(data => {
        this.lsStates = data
      }, error => console.log(error));
  }

  getSetores() {
    this.clientService
      .getSetores()
      .subscribe(
        data => (this.lsSetores = data),
        error => console.log(error)
      );
  }

  getVendedores(){
    this.parameters.vendedor = '';
    this.vendedorLoading = true;
    this.visitService.getVendedoresPorSetor(this.vetorSetor.codigo).subscribe(
      data => {
        this.lsVendedores = data;

        if (data.length == 1) {
          this.parameters.vendedor = data[0];
        }
        else {
          this.parameters.vendedor = null;
        }

        this.vendedorLoading = false;
    },
      error => console.log(error)
    );
  }

  filterCities() {
  
    console.log(this.parameters.uf);
    console.log(this.parameters.setor);
    this.cidadeLoading = true;

    this.clientService
      .getCities(this.parameters.uf.idUf, this.parameters.setor)
      .subscribe(
        data => {
          this.lsCities = data;

          if (data.length == 1) {
            this.parameters.cidade = data[0];
          }
          else {
            this.parameters.cidade = null;
          }
          this.cidadeLoading = false;
        },
        error => console.log(error)
      );
  }

  getClients() {
    this.isRequesting = true;

    const parameters = { ...this.parameters };
    
    parameters.cnpj = parameters.cnpj.replace(/[^\d]/g, "");

    if(!this.vetorSetor){
      toastr.error('Campo "setor" Obrigatório')
      return this.isRequesting = false;
    }
    
    if(!parameters.vendedor){
      toastr.error('Campo "Vendedor" Obrigatório');
      return this.isRequesting = false;
    }
    else {
      parameters.vendedor = parameters.vendedor.setor;
    }

    if(!parameters.cidade){
      parameters.cidade = "0";
    }
    else { 
      parameters.cidade = parameters.cidade.idMunic;
    }    

    if(parameters.uf){
      parameters.uf = parameters.uf.idUf;
    }

    Object.keys(parameters).forEach(key => {
      if (!parameters[key]) {
        delete parameters[key];
      }
    });

    this.lsTotalStatus = [];
    console.log("parameters", parameters)
    
    this.clientService
      .getCarteiraPedido(parameters)
      .finally(() => (this.isRequesting = false))
      .subscribe(
        data => {
          const lsTotalStatus =  [] ;

          this.lsStatus.map(item => lsTotalStatus.push({...item}))

          data.forEach(element => {
            const statusIndex = lsTotalStatus
              .map(item => item.dsSit)
              .indexOf(element.status);

            if(!lsTotalStatus[statusIndex].value){
              lsTotalStatus[statusIndex].value=0
            }

            if (statusIndex >= 0) {
             lsTotalStatus[statusIndex].value += element.valor;
            }
          });
          
          
          // if (parameters.idStatus) {
          //   lsClientStatus.forEach((element, index) => {
          //     if (element.value === 0) {
          //       lsClientStatus[index].value = "-";
          //     }
          //     lsClientStatus[index].value = lsClientStatus[index].value.toFixed(2)
          //   });
          // }
          
          this.lsTotalStatus = lsTotalStatus;

          this.lsClients = data;
        },
        error => console.log(error)
      );
      
  }

  reset() {
    this.parameters = {
      setor: this.userLogado.perfil !== 3 ? this.userLogado.idSetor : '',
      pedido: "",
      periodoInicial: "",
      periodoFinal: "",
      cnpj: "",
      uf: "",
      cidade: null,
      linhas: "",
      idStatus: "",
      idTabelaPreco: "",
      vendedor: null,
      CdFzs: "",
      pedidosReativos: false,
      pedidosComSaldo: false,
      pedidosTelevendas: false
    };

    this.lsClients = [];
  }

  formatCnpj(v) {
    if (v) return Utilservice.formatCnpj(v);
  }

  formatDate(date) {
    if (date) {
      if (date.indexOf("T") >= 0) {
        const dateSplit = date.split("T");

        date = dateSplit[0];

        date = date
          .split("-")
          .reverse()
          .join("/");
      }

      return Utilservice.formatDate(date);
    }
  }

  formatCep(cep) {
    if (cep) return Utilservice.formatCep(cep);
  }

  blockAllButPositiveNumbers(event){
    if (
      (event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105) &&
      event.keyCode != 8 &&
      event.keyCode != 13 &&
      event.keyCode != 46 &&
      event.keyCode != 37 &&
      event.keyCode != 39
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  getIdSetorComc(){
    if(this.vetorSetor){
      this.parameters.CdFzs = this.vetorSetor.codigo;
      this.setorFzs = this.vetorSetor.codigo;
    }
    this.clientService.getIdSetor(this.setorFzs)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            this.parameters.setor = idSetor;
            //this.getStates(idSetor);
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  onSetorChange(event){
    this.debouncedGetSetor()
  }

  formatMoneyValue(value){
    return Utilservice.formatMoney(value)
  }

  formatQuantity(value) {
    return Utilservice.formatQuantity(value)
  }
}